(function($) {     

    $(".point").click(function(){
        $('.point').removeClass("active");
        $(this).addClass("active");       
    });

    $(".pop_up_link").on("click", function(event) {
        console.log(event);
        var pop_to_show = $(this).attr("data-attr");
        $(".pop_up_link").removeClass("active_tab");
        $(this).addClass("active_tab");
        $(".popup").removeClass("active_hidden_section");
        $("." + pop_to_show).addClass("active_hidden_section");
    });

    $(".close_pop").on("click", function(event) {
        console.log(event);
        $(".popup").removeClass("active_hidden_section");
    });

    $(".faq_title").on("click", function() {
        console.log("Please");
      
        var sectors_to_show = $(this).attr("data-attr");
      
        $(".faq_title").removeClass("active_tab");
        $('.faq__expand-arrow').removeClass("faq__expand-arrow__active");
        $(".faq_content").removeClass("active_hidden_section");

        if (!$(this).hasClass("active_tab")) {
          $(this).toggleClass("active_tab");
          $(this).find('.faq__expand-arrow').toggleClass("faq__expand-arrow__active");
          $("." + sectors_to_show).toggleClass("active_hidden_section");
        }
    });

    $(".accordion_title").on("click", function(event) {
        console.log(event);
        var accordion_to_show = $(this).attr("data-attr");
        $(".accordion_title").removeClass("active");
        $(this).addClass("active");
        $(".accordion").removeClass("accordion_active_hidden_section");
        $("." + accordion_to_show).addClass("accordion_active_hidden_section");  
    });
    
    
})
(jQuery); 
